// document.addEventListener('DOMContentLoaded', function() {
//   const customSliders = document.querySelectorAll('.custom-slider-wrapper');
//   customSliders.forEach((sliderSection) => {
//     const track = sliderSection.querySelector('.slider-track');
//     const prevBtn = sliderSection.querySelector('.prev');
//     const nextBtn = sliderSection.querySelector('.next');

//     if (!track || !prevBtn || !nextBtn) return;

//     const getScrollAmount = () => {
//       const item = track.querySelector('.slider-item');
//       if (item) {
//         const itemWidth = item.offsetWidth;
//         const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
//         return itemWidth + gap;
//       }
//       return 0;
//     };

//     nextBtn.addEventListener('click', () => {
//       track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
//     });

//     prevBtn.addEventListener('click', () => {
//       track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
//     });
//   });
// });


// Products Slider
// document.addEventListener('DOMContentLoaded', function() {
//   const customSliders = document.querySelectorAll('.custom-slider-wrapper');
//   customSliders.forEach((sliderSection) => {
//     const track = sliderSection.querySelector('.slider-track');
//     const prevBtn = sliderSection.querySelector('.prev');
//     const nextBtn = sliderSection.querySelector('.next');

//     if (!track || !prevBtn || !nextBtn) return;

//     const getScrollAmount = () => {
//       const item = track.querySelector('.slider-item');
//       if (item) {
//         const itemWidth = item.offsetWidth;
//         const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
//         return itemWidth + gap;
//       }
//       return 0;
//     };

//     const updateArrowVisibility = () => {
//       if (track.scrollLeft <= 1) {
//         prevBtn.style.display = 'none';
//       } else {
//         prevBtn.style.display = ''; 
//       }

//       if (Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth) {
//         nextBtn.style.display = 'none';
//       } else {
//         nextBtn.style.display = '';
//       }
//     };

//     updateArrowVisibility();

//     track.addEventListener('scroll', updateArrowVisibility);
//     window.addEventListener('resize', updateArrowVisibility);

//     nextBtn.addEventListener('click', () => {
//       track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
//     });

//     prevBtn.addEventListener('click', () => {
//       track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
//     });
//   });
// });

// Products Slider
document.addEventListener('DOMContentLoaded', function() {
  const customSliders = document.querySelectorAll('.custom-slider-wrapper');
  customSliders.forEach((sliderSection) => {
    const track = sliderSection.querySelector('.slider-track');
    const prevBtn = sliderSection.querySelector('.prev');
    const nextBtn = sliderSection.querySelector('.next');

    if (!track || !prevBtn || !nextBtn) return;

    const getScrollAmount = () => {
      const item = track.querySelector('.slider-item');
      if (item) {
        const itemWidth = item.offsetWidth;
        const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        return itemWidth + gap;
      }
      return 0;
    };

    const updateArrowVisibility = () => {
      const atStart = track.scrollLeft <= 1;
      const atEnd = Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth - 1;

      prevBtn.style.display = 'flex';
      nextBtn.style.display = 'flex';
      prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
    };

    updateArrowVisibility();

    track.addEventListener('scroll', updateArrowVisibility);
    window.addEventListener('resize', updateArrowVisibility);

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    // --- AUTO-SCROLL ---
    const enableAutoplay = sliderSection.dataset.autoplay !== 'false';
    const autoScrollSpeed = Math.max(
      2000,
      parseInt(sliderSection.dataset.autoplaySpeed, 10) || 5000
    );
    let autoScrollTimer;

    const startAutoScroll = () => {
      if (!enableAutoplay) return;
      stopAutoScroll();
      autoScrollTimer = setInterval(() => {
        if (Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth - 1) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        }
      }, autoScrollSpeed);
    };

    const stopAutoScroll = () => {
      clearInterval(autoScrollTimer);
    };

    if (enableAutoplay) {
      sliderSection.addEventListener('mouseenter', stopAutoScroll);
      sliderSection.addEventListener('mouseleave', startAutoScroll);
      sliderSection.addEventListener('touchstart', stopAutoScroll, { passive: true });
      sliderSection.addEventListener('touchend', startAutoScroll, { passive: true });
      startAutoScroll();
    }
  });
});



// Product page Description / How to Use / Ingredients tabs
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-product-tabs').forEach(function (tabsRoot) {
    const tabLinks = tabsRoot.querySelectorAll('.tab-links a');
    const container = tabsRoot.querySelector('.tab-content-container');

    tabLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const targetId = this.getAttribute('href');
        if (!targetId || targetId === '#') return;

        const targetPane = tabsRoot.querySelector(targetId);
        if (!targetPane || targetPane.classList.contains('active')) return;

        const activeLink = tabsRoot.querySelector('.tab-links li.active');
        const activePane = tabsRoot.querySelector('.tab-pane.active');

        animateContainerToContent(container, function () {
          if (activePane && activePane !== targetPane) {
            activePane.classList.remove('active');
          }

          this.parentElement.classList.add('active');
          this.setAttribute('aria-selected', 'true');
          targetPane.classList.add('active');

          if (activeLink && activeLink !== this.parentElement) {
            activeLink.classList.remove('active');
            const prevLink = activeLink.querySelector('a');
            if (prevLink) prevLink.setAttribute('aria-selected', 'false');
          }
        }.bind(this));
      });
    });
  });
});

// 





// Frequently Bought Together (accordion routine builder)
function formatMoneyAUD(cents) {
  const amount = (Number(cents) || 0) / 100;
  return (
    '$' +
    amount.toLocaleString('en-AU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) +
    ' AUD'
  );
}

function abbHasUpezCart() {
  const nativeCart = document.querySelector('cart-drawer');
  const upezHidden =
    !!nativeCart &&
    (nativeCart.classList.contains('upez-hide') ||
      getComputedStyle(nativeCart).display === 'none');
  return (
    typeof (window.UPEZ && window.UPEZ.openCart) === 'function' ||
    typeof window.openUpnovaCart === 'function' ||
    !!document.getElementById('upezCart') ||
    upezHidden
  );
}

function abbOpenUpezCart() {
  abbWatchUpezCartClose();

  window.setTimeout(function () {
    try {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (cartLink) {
        cartLink.click();
        return;
      }
    } catch (error) {
      console.error(error);
    }

    try {
      if (typeof window.openUpnovaCart === 'function') window.openUpnovaCart();
    } catch (error) {}

    try {
      if (window.UPEZ && typeof window.UPEZ.openCart === 'function') window.UPEZ.openCart();
    } catch (error) {}
  }, 80);

  return true;
}

function abbWatchUpezCartClose() {
  if (window.__abbUpezCloseWatch) return;
  window.__abbUpezCloseWatch = true;

  const unlockSoon = function () {
    window.setTimeout(abbUnlockPage, 60);
  };

  document.addEventListener('UPEZ_CART_CLOSED', unlockSoon);
  document.addEventListener('upez:cart:closed', unlockSoon);
  window.addEventListener(
    'keydown',
    function (event) {
      if (event.key === 'Escape') unlockSoon();
    },
    true
  );
}

function abbUnlockPage() {
  const cart = document.querySelector('cart-drawer');
  if (cart) {
    cart._pendingOpen = false;
    cart._drawerOpen = false;
    if (typeof cart.unlockPageScroll === 'function') cart.unlockPageScroll();
  }
  if (typeof removeTrapFocus === 'function') removeTrapFocus();
  document.body.classList.remove(
    'overflow-hidden',
    'overflow-hidden-mobile',
    'overflow-hidden-tablet',
    'overflow-hidden-desktop'
  );
  document.documentElement.classList.remove('overflow-hidden');
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('touch-action');
  document.body.style.removeProperty('padding-right');
  document.body.style.removeProperty('position');
  document.documentElement.style.removeProperty('overflow');
  document.documentElement.style.removeProperty('scroll-behavior');
}

function abbUpdateCartIcon(response) {
  const html = response && response.sections && response.sections['cart-icon-bubble'];
  const icon = document.getElementById('cart-icon-bubble');
  if (!html || !icon) return;
  try {
    const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (parsed) icon.innerHTML = parsed.innerHTML;
  } catch (error) {
    console.error(error);
  }
}

function abbGetCartUi() {
  return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
}

function abbOpenCartWithResponse(response) {
  abbUpdateCartIcon(response);

  if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: response });
  }
  document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: response }));
  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: response }));

  if (abbHasUpezCart() && abbOpenUpezCart()) {
    abbUnlockPage();
    return;
  }

  const cart = abbGetCartUi();
  const trigger = document.querySelector('#cart-icon-bubble') || document.body;

  if (!cart) {
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    return;
  }

  if (typeof cart.setActiveElement === 'function') {
    cart.setActiveElement(trigger);
  }

  try {
    if (cart.classList) cart.classList.remove('is-empty');

    if (typeof cart.renderContents === 'function' && response && response.sections) {
      cart.renderContents(response);
    } else if (typeof cart.open === 'function') {
      cart.open(trigger);
    } else {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }
  } catch (error) {
    console.error(error);
    abbUnlockPage();
    if (abbHasUpezCart()) abbOpenUpezCart();
  }
}

function abbAddItemsAndOpenCart(items, button) {
  if (!items || !items.length) return Promise.resolve();

  const cart = abbGetCartUi();
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const sectionIds =
    cart && typeof cart.getSectionsToRender === 'function'
      ? cart.getSectionsToRender().map((section) => section.id)
      : ['cart-drawer', 'cart-icon-bubble'];

  if (button) {
    button.setAttribute('aria-disabled', 'true');
    button.disabled = true;
  }

  return fetch(root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: items,
      sections: sectionIds,
      sections_url: window.location.pathname,
    }),
  })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((data) => {
          throw new Error(data.description || data.message || 'Unable to add to cart');
        });
      }
      return response.json();
    })
    .then((response) => {
      if (response.status) {
        console.error(response.description || response.message || response);
        abbUnlockPage();
        return;
      }
      abbOpenCartWithResponse(response);
    })
    .catch((error) => {
      console.error(error);
      abbUnlockPage();
    })
    .finally(() => {
      if (button) {
        button.removeAttribute('aria-disabled');
        button.disabled = false;
      }
    });
}

window.abbHasUpezCart = abbHasUpezCart;
window.abbOpenUpezCart = abbOpenUpezCart;
window.abbGetCartUi = abbGetCartUi;
window.abbOpenCartWithResponse = abbOpenCartWithResponse;
window.abbAddItemsAndOpenCart = abbAddItemsAndOpenCart;

document.addEventListener('DOMContentLoaded', abbWatchUpezCartClose);

window.addEventListener('unhandledrejection', function (event) {
  const reason = event.reason;
  const message = String((reason && reason.message) || reason || '');
  const stack = String((reason && reason.stack) || '');
  if (/Failed to fetch/i.test(message) && /winston|upez|msha|cart-winston/i.test(stack)) {
    event.preventDefault();
  }
});

function setupFBTMath(root) {
  const wrapper = root || document.querySelector('.abb-fbt.complementary-products-wrapper, .complementary-products-wrapper.abb-fbt');
  if (!wrapper) return;

  const checkboxes = wrapper.querySelectorAll('.fbt-checkbox');
  const priceSpan = wrapper.querySelector('#fbt-total-price');
  const countSpan = wrapper.querySelector('#fbt-count');
  const saveSpan = wrapper.querySelector('#fbt-save-amount');
  const addButton = wrapper.querySelector('#fbt-add-button');
  const savePercent = Math.max(0, parseFloat(wrapper.dataset.savePercent || '10') || 0);

  const update = () => {
    let total = 0;
    let count = 0;
    wrapper.querySelectorAll('.fbt-checkbox:checked').forEach((cb) => {
      const item = cb.closest('.fbt-item');
      if (!item) return;
      total += parseInt(item.dataset.price, 10) || 0;
      count += 1;
    });

    const saveAmount = Math.round(total * (savePercent / 100));

    if (priceSpan) priceSpan.textContent = formatMoneyAUD(total);
    if (countSpan) countSpan.textContent = String(count);
    if (saveSpan) saveSpan.textContent = formatMoneyAUD(saveAmount);
    if (addButton) addButton.disabled = count === 0;
  };

  checkboxes.forEach((cb) => cb.addEventListener('change', update));
  update();

  if (addButton && !addButton.dataset.bound) {
    addButton.dataset.bound = 'true';
    addButton.addEventListener('click', function () {
      const items = [];
      wrapper.querySelectorAll('.fbt-checkbox:checked').forEach((cb) => {
        const item = cb.closest('.fbt-item');
        if (!item) return;
        items.push({ id: item.dataset.variantId, quantity: 1 });
      });
      if (!items.length) return;
      abbAddItemsAndOpenCart(items, addButton);
    });
  }

  const toggle = wrapper.querySelector('.abb-fbt__toggle');
  const panel = wrapper.querySelector('.abb-fbt__panel');
  if (toggle && panel && !toggle.dataset.bound) {
    toggle.dataset.bound = 'true';
    panel.inert = !wrapper.classList.contains('is-open');
    toggle.addEventListener('click', function () {
      const isOpen = wrapper.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      panel.inert = !isOpen;
    });
  }
}

function initFBT() {
  const wrapper = document.querySelector('.abb-fbt.complementary-products-wrapper, .complementary-products-wrapper.abb-fbt');
  if (!wrapper) return;

  // Server-rendered with same matching as Complete the Routine — no AJAX override
  if (wrapper.dataset.serverRendered === 'true' || wrapper.querySelectorAll('.fbt-item').length >= 2) {
    setupFBTMath(wrapper);
    return;
  }
}

document.addEventListener('DOMContentLoaded', initFBT);

function prefersReducedMotion() {
  return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function clearAnimatedHeight(container) {
  if (!container) return;
  if (container._abbHeightEnd) {
    container.removeEventListener('transitionend', container._abbHeightEnd);
    container._abbHeightEnd = null;
  }
  container.style.height = '';
  container.style.overflow = '';
  container.style.transition = '';
}

function animateContainerToContent(container, applyChange) {
  if (typeof applyChange !== 'function') return;
  if (!container || prefersReducedMotion()) {
    applyChange();
    clearAnimatedHeight(container);
    return;
  }

  const startHeight = container.offsetHeight;
  clearAnimatedHeight(container);

  container.style.overflow = 'hidden';
  container.style.transition = 'none';
  container.style.height = startHeight + 'px';
  applyChange();

  container.style.height = 'auto';
  const endHeight = container.offsetHeight;
  container.style.height = startHeight + 'px';

  if (Math.abs(startHeight - endHeight) < 1) {
    clearAnimatedHeight(container);
    return;
  }

  container.offsetHeight;
  container.style.transition = 'height 0.4s ease';
  container.style.height = endHeight + 'px';

  const onEnd = function (event) {
    if (event.propertyName && event.propertyName !== 'height') return;
    clearAnimatedHeight(container);
  };
  container._abbHeightEnd = onEnd;
  container.addEventListener('transitionend', onEnd);
}

function animatePanelHeight(panel, expand) {
  if (!panel) return;
  if (prefersReducedMotion()) {
    panel.style.height = expand ? 'auto' : '0px';
    return;
  }

  const startHeight = expand ? 0 : panel.scrollHeight;
  const endHeight = expand ? panel.scrollHeight : 0;

  panel.style.height = startHeight + 'px';
  panel.offsetHeight;
  panel.style.height = endHeight + 'px';

  const onEnd = (event) => {
    if (event.propertyName !== 'height') return;
    panel.style.height = expand ? 'auto' : '0px';
    panel.removeEventListener('transitionend', onEnd);
  };
  panel.addEventListener('transitionend', onEnd);
}

function setupSmoothProductAccordions() {
  document.querySelectorAll(
    '.product__info-container .product__accordion details, .abb-ingredients-full'
  ).forEach((details) => {
    if (details.dataset.smoothBound === 'true') return;
    details.dataset.smoothBound = 'true';

    const summary = details.querySelector('summary');
    const content =
      details.querySelector('.accordion__content') ||
      details.querySelector('.abb-ingredients-full-body');
    if (!summary || !content) return;

    if (!details.open) {
      content.style.height = '0px';
    }

    let closing = false;
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (closing) return;

      const opening = !details.open;

      if (opening) {
        details.setAttribute('open', '');
        animatePanelHeight(content, true);
        return;
      }

      closing = true;
      animatePanelHeight(content, false);
      if (prefersReducedMotion()) {
        details.removeAttribute('open');
        closing = false;
        return;
      }
      const onEnd = (e) => {
        if (e.propertyName !== 'height') return;
        details.removeAttribute('open');
        closing = false;
        content.removeEventListener('transitionend', onEnd);
      };
      content.addEventListener('transitionend', onEnd);
    });
  });
}

function extractIngredientItems(container) {
  const items = [];

  container.querySelectorAll('li').forEach(function (li) {
    const text = li.textContent.trim().replace(/^[·•\-\u00b7]\s*/, '');
    if (text) items.push(text);
  });

  if (items.length) return items;

  const text = container.textContent.trim();
  if (!text) return items;

  return text
    .split(/\n|,|;/)
    .map(function (part) {
      return part.trim().replace(/^[·•\-\u00b7]\s*/, '');
    })
    .filter(Boolean);
}

function rebuildIngredientList(container, items) {
  const list = document.createElement('ul');
  list.className = 'abb-ingredients-list';

  items.forEach(function (item) {
    const li = document.createElement('li');
    li.textContent = item;
    list.appendChild(li);
  });

  container.innerHTML = '';
  container.appendChild(list);
}

function getKeyActivesStyle(activesWrap) {
  return activesWrap && activesWrap.dataset.keyActivesStyle === 'bullet' ? 'bullet' : 'comma';
}

function renderKeyActives(container, items, style) {
  if (!container || !items.length) return;

  if (style === 'bullet') {
    rebuildIngredientList(container, items);
    return;
  }

  container.innerHTML = '';
  container.textContent = items.join(', ');
}

function setupIngredientsSplit(root) {
  (root || document).querySelectorAll('[data-split-ingredients="true"]').forEach(function (details) {
    const tabPane = details.closest('.tab-pane');
    if (!tabPane || tabPane.dataset.ingredientsSplit === 'true') return;

    const fullBody = details.querySelector('.abb-ingredients-full-body');
    const activesWrap = tabPane.querySelector('[data-auto-key-actives="true"]');
    const activesBody = activesWrap ? activesWrap.querySelector('.abb-ingredients-actives-body') : null;
    if (!fullBody) return;

    const items = extractIngredientItems(fullBody);
    if (!items.length) return;

    tabPane.dataset.ingredientsSplit = 'true';

    const keyItems = items.slice(0, 5);
    const restItems = items.slice(5);
    const style = getKeyActivesStyle(activesWrap);

    if (activesBody && !activesBody.textContent.trim()) {
      renderKeyActives(activesBody, keyItems, style);
    }

    if (restItems.length === 0) {
      details.hidden = true;
      return;
    }

    rebuildIngredientList(fullBody, restItems);
  });
}

function setupKeyActivesDisplay(root) {
  (root || document)
    .querySelectorAll('.abb-ingredients-actives:not([data-auto-key-actives="true"])')
    .forEach(function (activesWrap) {
      if (activesWrap.dataset.keyActivesFormatted === 'true') return;

      const activesBody = activesWrap.querySelector('.abb-ingredients-actives-body');
      if (!activesBody || !activesBody.textContent.trim()) return;

      const items = extractIngredientItems(activesBody);
      if (!items.length) return;

      activesWrap.dataset.keyActivesFormatted = 'true';
      renderKeyActives(activesBody, items, getKeyActivesStyle(activesWrap));
    });
}

document.addEventListener('DOMContentLoaded', function () {
  setupIngredientsSplit(document);
  setupKeyActivesDisplay(document);
  setupSmoothProductAccordions();
});

window.addEventListener('resize', function () {
  document.querySelectorAll('.custom-product-tabs .tab-content-container').forEach(clearAnimatedHeight);
});

function setupPdpBundle(root) {
  const wrapper = root || document.querySelector('.abb-pdp-bundle');
  if (!wrapper || wrapper.dataset.bound === 'true') return;
  wrapper.dataset.bound = 'true';

  const sectionId = (wrapper.id || '').replace('AbbPdpBundle-', '');
  const priceSpan = wrapper.querySelector('#abb-bundle-total-' + sectionId) || wrapper.querySelector('[id^="abb-bundle-total-"]');
  const countSpan = wrapper.querySelector('#abb-bundle-count-' + sectionId) || wrapper.querySelector('[id^="abb-bundle-count-"]');
  const saveSpan = wrapper.querySelector('#abb-bundle-save-' + sectionId) || wrapper.querySelector('[id^="abb-bundle-save-"]');
  const addButton = wrapper.querySelector('#abb-bundle-add-' + sectionId) || wrapper.querySelector('[id^="abb-bundle-add-"]');
  const savePercent = Math.max(0, parseFloat(wrapper.dataset.savePercent || '10') || 0);

  const update = () => {
    let total = 0;
    let count = 0;
    wrapper.querySelectorAll('.fbt-checkbox:checked').forEach((cb) => {
      const item = cb.closest('.fbt-item');
      if (!item) return;
      total += parseInt(item.dataset.price, 10) || 0;
      count += 1;
    });

    const saveAmount = Math.round(total * (savePercent / 100));

    if (priceSpan) priceSpan.textContent = formatMoneyAUD(total);
    if (countSpan) countSpan.textContent = String(count);
    if (saveSpan) saveSpan.textContent = formatMoneyAUD(saveAmount);
    if (addButton) addButton.disabled = count === 0;
  };

  wrapper.querySelectorAll('.fbt-checkbox').forEach((cb) => cb.addEventListener('change', update));
  update();

  if (addButton) {
    addButton.addEventListener('click', function () {
      const items = [];
      wrapper.querySelectorAll('.fbt-checkbox:checked').forEach((cb) => {
        const item = cb.closest('.fbt-item');
        if (!item) return;
        items.push({ id: item.dataset.variantId, quantity: 1 });
      });
      if (!items.length) return;
      abbAddItemsAndOpenCart(items, addButton);
    });
  }

  const toggle = wrapper.querySelector('.abb-pdp-bundle__toggle');
  const panel = wrapper.querySelector('.abb-pdp-bundle__panel');
  const icon = wrapper.querySelector('.abb-pdp-bundle__toggle-icon');
  if (toggle && panel) {
    toggle.addEventListener('click', function () {
      const isOpen = wrapper.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        panel.removeAttribute('hidden');
        if (icon) icon.textContent = '−';
      } else {
        panel.setAttribute('hidden', '');
        if (icon) icon.textContent = '+';
      }
    });
  }
}

function initPdpBundle() {
  document.querySelectorAll('.abb-pdp-bundle').forEach(setupPdpBundle);
}

document.addEventListener('DOMContentLoaded', initPdpBundle);


  // Routine Products
   function loadRoutine() {
    const container = document.querySelector('.complementary-routine');
    if (!container) return;

    fetch(container.dataset.url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const content = doc.querySelector('.complementary-routine').innerHTML;
        if (content.trim().length > 50) {
          container.innerHTML = content;
          bindRoutineCalculations();
        }
      });
  }

  function bindRoutineCalculations() {
    const checkboxes = document.querySelectorAll('.routine-checkbox');
    
    const recalculate = () => {
      let total = 0; let count = 0;
      document.querySelectorAll('.routine-checkbox:checked').forEach(box => {
        total += parseInt(box.closest('.routine-item').dataset.price);
        count++;
      });
      document.getElementById('routine-total-price').textContent = (total / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
      document.getElementById('routine-count').textContent = count;
    };

    checkboxes.forEach(box => box.addEventListener('change', recalculate));
    recalculate(); // initial run

    // Add multiple to cart
    document.getElementById('routine-add-button').addEventListener('click', function() {
      let items = [];
      document.querySelectorAll('.routine-checkbox:checked').forEach(box => {
        items.push({ id: box.closest('.routine-item').dataset.variantId, quantity: 1 });
      });
      abbAddItemsAndOpenCart(items, this);
    });
  }

  document.addEventListener('DOMContentLoaded', loadRoutine);

$(document).ready(function () {
  if (typeof window.moveCollectionFacetsBeforeTabs === 'function') {
    window.moveCollectionFacetsBeforeTabs();
    return;
  }

  var target = $('.Collection-tabbing-section.page-width').first();
  if (!target.length) return;

  $('.mobile-facets__wrapper').insertBefore(target);
  $('.active-facets.active-facets-desktop').insertBefore(target);
  target.parent().addClass('facets-positioned');
  document.dispatchEvent(new CustomEvent('collection:facets-moved'));
});

$(document).ready(function() {

  function moveWishlist() {
    var wishlist = $('.swym-button-bar');
    var target = $('.product-form__buttons');

    if (wishlist.length && target.length) {
      wishlist.insertAfter(target);
    }
  }

  // Run on load
  moveWishlist();

  // Run again after delay (for app load)
  setTimeout(moveWishlist, 1500);

});

document.addEventListener("DOMContentLoaded", function () {

  // Keep reviews/rating with product details under the gallery on mobile
  // (do not move into .mobile-product-top)

});


// Footer Accordian
  document.addEventListener('DOMContentLoaded', function() {
    const triggers = document.querySelectorAll('.accordion-trigger');
    
    triggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        if (window.innerWidth <= 989) {
          const content = this.nextElementSibling;
          const icon = this.querySelector('.accordion-icon');
          
          if (content.classList.contains('is-open')) {
            content.classList.remove('is-open');
            icon.textContent = '+';
          } else {
            content.classList.add('is-open');
            icon.textContent = '-'; 
          }
        }
      });
    });
  });

/* Flexible payment options — delegated so it works on all product templates / after section re-renders */
document.addEventListener('click', function (event) {
  const btn = event.target.closest('.abb-payment-toggle');
  if (!btn) return;

  event.preventDefault();
  document.body.classList.toggle('abb-payments-open');
  btn.classList.toggle('is-open');
  btn.setAttribute('aria-expanded', btn.classList.contains('is-open') ? 'true' : 'false');
});

/* PDP Yotpo star rating → scroll to reviews widget */
document.addEventListener('click', function (event) {
  if (!document.body.classList.contains('product-page')) return;

  const star = event.target.closest(
    '.yotpo-reviews-star-ratings-widget, .yotpo-sr-bottom-line-summary, .yotpo-sr-bottom-line-button, .yotpo-sr-bottom-line-text'
  );
  if (!star) return;
  if (star.closest('#product-reviews, .abb-reviews-panel, .yotpo-main-widget')) return;

  const target =
    document.getElementById('product-reviews') ||
    document.querySelector('.abb-reviews-panel, .yotpo-main-widget');
  if (!target) return;

  event.preventDefault();
  event.stopPropagation();

  const headerOffset =
    parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
  const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - 16;
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
});